module.exports = __webpack_public_path__ + "img/partner-4.ca92ed63.png";